"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedTwitterPartialForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../../dsl/backoffice");
const version_abstract_form_1 = require("../version.abstract.form");
let EmbedTwitterPartialForm = class EmbedTwitterPartialForm extends version_abstract_form_1.EmbedVersionAbstractForm {
    constructor() {
        super(...arguments);
        /**
         * Regular expression to identify file type
         * @private
         */
        this.regex = /twitter\.com\/.*\/status(?:es)?\/([^/?]+)/;
    }
};
EmbedTwitterPartialForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'EmbedIframeForm',
        components: {
            DashmixTextArea: backoffice_1.DashmixTextArea,
            DashmixInput: backoffice_1.DashmixInput
        },
        template: `
  <div>
    <div class="form-group">
      <div class="form-group">
        <label for="iframe">{{ $t('forms.embed.iframe.label.twitter') }}</label>
        <DashmixTextArea :model.sync="_content.twitter" :placeholder="$t('forms.embed.iframe.placeholder.twitter')" name="twitter" />
      </div>

      <div class="form-group">
        <label for="description" class="mt-3">{{ $t('forms.embed.description') }}</label>
        <DashmixInput :model.sync="_content.description" name="description" />
      </div>
    </div>
  </div>
  `
    })
], EmbedTwitterPartialForm);
exports.EmbedTwitterPartialForm = EmbedTwitterPartialForm;
//# sourceMappingURL=EmbedTwitter.form.js.map